import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styles from "./TimeSheetSidebar.module.scss";
import _ from "../../i18n";
import { VerticalLineIcon } from "../common/Icons/VerticalLineIcon";
import { Tooltip } from "antd";
import { OpenEye } from "../common/Icons/OpenEye";
import { CloseEye } from "../common/Icons/CloseEye";
import { IconClose } from "../common/Icons/IconClose";


const SchemaSidebar = ({ onClose, allTypes, onSave }) => {
  const [items, setItems] = useState(
    allTypes.map((type, index) => ({
      id: `item-${index + 1}`,
      content: type,
      visible: true,
    }))
  );
  const [initialItems] = useState(
    allTypes.map((type, index) => ({
      id: `item-${index + 1}`,
      content: type,
      visible: true,
    }))
  );
  

  const handleSave = () => {
    if (onSave) {
      onSave(items); 
    }
  };
  const handleCancel = () => {
    onClose();
  };
  const handleReset = () => {
    setItems(initialItems);
  };
  

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newItems = reorder(items, result.source.index, result.destination.index);
    setItems(newItems);
  };

  const toggleVisibility = (item) => {
    setItems((prev) =>
      prev.map((el) =>
        el.id === item.id ? { ...el, visible: !el.visible } : el
      )
    );
  };

  const getItemStyle = (isDragging, draggableStyle, index) => ({
    width: "300px",
    height: "38.59px",
    fontWeight: 500,
    color: "rgb(41, 57, 77)",
    fontStyle: "normal",
    fontFamily: "Roboto",
    display: "flex",
    borderRadius: "4px",
    userSelect: "none",
    padding: "10px 25px",
    margin: "0px 0px 11px",
    marginLeft: index === 1 ? "20px" : index === 2 ? "40px" : "0px",
    background: isDragging ? "#D0F0FD" : "rgb(255, 255, 255)",
    alignItems: "center",
    justifyContent: "start",
    boxShadow: "rgba(41, 57, 77, 0.1) 0px 4px 10px",
    ...draggableStyle
  });
  
  

  return (
    <div className={styles.schemasidebar}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>{_("")}</h2>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <IconClose />
        </div>
      </div>

      <h2 style={{ margin: "15px 10px"}}>{_("cycleLabel")}</h2>
      <p style={{ margin: "15px 10px" }}>Glisser-déposer pour changer l’ordre des onglets</p>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              className={styles.droppableContainer}
              ref={provided.innerRef}
              style={{ minHeight: "100px" }}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style,index)}
                    >
                      <VerticalLineIcon />
                      <div style={{ paddingLeft: 10, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>{item.content}</div>
                        <Tooltip
                          placement="bottom"
                          title={item.visible ? _("Cacher") : _("Visualiser")}
                        >
                          <span
                            onClick={() => toggleVisibility(item)}
                            className={styles.eye}
                          >
                            {item.visible ? <OpenEye /> : <CloseEye />}
                          </span>
                        </Tooltip>
                      </div>

                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <hr style={{ margin: "15px 10px", borderBottom: "1px solid #EAEDF0" }} />

      <section style={{ display: "flex", justifyContent: "flex-end", margin: "20px 7px" }}>
        <button
         onClick={handleCancel}  
          style={{
            height: 35,
            marginRight: 5,
            padding: "8px 19px",
            background: "white",
            color: "#6D7F92",
            boxSizing: "border-box",
            border: "0.5px solid rgba(245, 245, 245)",
            borderRadius: 3 

          }}
        >
          {_("cancel")}
        </button>
        <button
         onClick={handleReset}
          style={{
            height: 35,
            marginRight: 5,
            background: "#5F9EA0",
            color: "white",
            boxSizing: "border-box",
            border: "0.5px solid rgba(245, 245, 245)",
            borderRadius: 3 
          }}
        >
          {_("Actualiser")}
        </button>
        <button
          type={"success"}
          style={{
            height: 35,
            marginRight: 5,
            padding: "0px 30px",
            background: "#0EBF9E",
            color: "white",
            border: "0.5px solid rgba(245, 245, 245)",
            borderRadius: 3 
          }}
          onClick={handleSave}
        >
          {_("save")}
        </button>
      </section>
    </div>
  );
};

export default SchemaSidebar;
